<template>
  <div>
    <!-- exam-section -->
    <div @click.self="customPopupClose" class="exam-section hide">
      <div class="exam-section-inner">
        <div @click="this.customPopupClose" class="exam-section-close">
          <i style="cursor: pointer;" class="fas fa-times fa-2x"></i>
        </div>
        <!-- exam-content -->
        <div class="exam-content exam">
          <div v-if="checkAnswers === false" class="scrollbar-box style-3">
            <div v-if="singleExam.name==='audio'">
              <h4 class="mb-3"> {{audio.title}}</h4>
              <img v-if="audioUrl === 'meet'" style="max-height:40vh" src="../assets/static/girl.jpg" alt="">
              <img v-else style="max-height:40vh" src="../assets/static/boy.jpg" alt="">
              <p class="mt-3" v-html="audio.content">
                {{audio.content}}
              </p>
              <audio controls class="player mt-3">
                <source v-if="audioUrl === 'meet'" :src="meet" type="audio/mpeg">
                <source v-else :src="introduce" type="audio/mpeg">
              </audio>
            </div>
            <div v-if="examData" class="content">
              <div v-show="currentQuestion === num + 1" v-for="(exam , num) in examData" :key="num">
                <h2 class="title">
                  Question - {{exam.examType}}
                </h2>
                <hr>
                <iframe v-show="exam.videoUrl" width="460" height="295" :src="`https://www.youtube.com/embed/${exam.videoUrl}`" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
                <p class="exam-title">{{exam.sort + 1}}. {{exam.title}}</p>
                <div class="option" v-for="(item , index) in exam.items" :key="index" @click="selectedAnswer(num + 1,index,exam.examType)">
                  <span v-if="exam.examType === 'single'" :class="{'isSelected': selectedData.some((el)=> {return el.num - 1 === num && el.answer === String.fromCharCode(65 + index) }) }">{{String.fromCharCode(65 + index)}} .{{ item }}</span>
                  <span v-if="exam.examType === 'multiple'" :class="{'isSelected': multipleSelected.some((el)=>{return el === String.fromCharCode(65 + index)})}">{{String.fromCharCode(65 + index)}} .{{ item }}</span>
                </div>
              </div>
              <div class="btn-group">
                <button v-if="isFinish || examData.length ===1" type="button" class="btn btn-success" @click="checkTheAnswers">解答</button>
                <button v-else type="button" class="btn btn-primary" @click="nextQuestion">下一題</button>
              </div>
            </div>
          </div>
          <div v-else>
            <span>答對率:{{rateOfAnswer}} %</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import api from '../api.js'
// import axios from 'axios'
import meet from '../assets/static/meet.mp3'
import introduce from '../assets/static/introduce.mp3'

export default {

  name: 'VrExam',
  mixins: [api],
  data () {
    return {
      examData: null,
      selectedData: [],
      checkAnswers: false,
      rateOfAnswer: 0,
      currentQuestion: 1,
      isFinish: false,
      multipleSelected: [],
      audio: {},
      audioUrl: '',
      meet: meet,
      introduce: introduce
    }
  },
  props: {
    singleExam: {
      type: Object,
      required: true
    }
  },
  watch: {
    singleExam (newVal, oldVal) {
      this.examData = newVal.practices
      if (newVal.name === 'audio') {
        this.audio = newVal
        this.audioUrl = newVal.audio
      }
    },
    audioUrl (val) {
      let player = document.querySelector('.player')
      player.pause()
      player.load()
    }
  },
  mounted () {
  },
  methods: {
    customPopupClose () {
      const customPopupSection = document.querySelector('.exam-section')
      const customPopupContentSections = document.querySelectorAll('.exam-content')
      customPopupSection.classList.add('hide')
      customPopupContentSections.forEach(function (contentSection) {
        if (!contentSection.classList.contains('hide')) {
          contentSection.classList.add('hide')
        }
      })
      this.resetExam()
      this.examData = null
      let player = document.querySelector('.player')
      player.pause()
      player.load()
      window.VRViewer.togglePanoramasList()
    },
    selectedAnswer (num, index, type) {
      if (type === 'single') {
        let selected = {
          'num': num,
          'answer': String.fromCharCode(65 + index)
        }
        let idx = this.selectedData.map((el) => { return el.num }).indexOf(selected.num)
        idx < 0 ? this.selectedData.push(selected) : (this.selectedData.splice(idx, 1, selected))
      }
      if (type === 'multiple') {
        let idx = this.multipleSelected.map((el) => { return el }).indexOf(String.fromCharCode(65 + index))
        idx < 0 ? this.multipleSelected.push(String.fromCharCode(65 + index)) : this.multipleSelected.splice(idx, 1)
        let selecteds = {
          'num': num,
          'answer': (this.multipleSelected).sort()
        }
        let i = this.selectedData.map((el) => { return el.num }).indexOf(selecteds.num)
        if (i < 0) this.selectedData.push(selecteds)
      }
    },
    nextQuestion () {
      this.multipleSelected = []
      if (this.currentQuestion < this.examData.length) {
        this.currentQuestion++
      }
      if (this.currentQuestion === this.examData.length) {
        this.isFinish = true
      }
    },
    checkTheAnswers () {
      this.checkAnswers = true
      // create answer
      let answers = []
      for (let i = 0; i < this.examData.length; i++) {
        let answer = {
          'num': i + 1,
          'answer': this.examData[i].answers
        }
        answers.push(answer)
      }
      // check the answers 單選/多選
      let result = []
      let correct = 0
      for (let i = 0; i < answers.length; i++) {
        for (let j = 0; j < this.selectedData.length; j++) {
          if (answers[i].num === this.selectedData[j].num) {
            if ([...answers[i].answer].sort().toString() === [...this.selectedData[j].answer].sort().toString()) {
              result.push('true')
              correct++
            } else {
              result.push('false')
            }
          }
        }
      }
      this.rateOfAnswer = (correct / answers.length) * 100
    },
    resetExam () {
      this.multipleSelected = []
      this.selectedData = []
      this.checkAnswers = false
      this.currentQuestion = 1
      this.isFinish = false
    }
  }
}
</script>

<style lang="scss" scoped>
/* exam section */
.hide {
  display: none;
}
.exam-section {
  width: 100%;
  height: 100%;
  position: fixed;
  top: 0;
}
.exam-section-inner {
  width: 60vw;
  min-height: 450px;
  position: fixed;
  top: 50%;
  transform: translateY(-50%);
  margin:0 20vw;
  z-index: 4;
}
.exam-section-close {
  position: absolute;
  right: 10px;
  color: #fff;
  z-index: 10;
}
.exam-content {
  height: 80vh;
  border-radius: 10px;
  position: relative;
  overflow: auto;
  background-color: rgba(88, 88, 90, 0.9);
  color: #fff;
  padding: 35px 20px;

  .title {
    font-size: 2rem;
  }
  .exam-title {
    white-space: pre-line;
    text-align: left;
    line-height: 2.5rem;
  }
  hr {
    height: 1px;
    width: 100%;
    margin: 5px 0;
  }
  .content {
    padding: 5%;
    display: flex;
    flex-direction: column;
    align-items: center;

    .exam-title {
      font-size: 1.25rem;
      line-height: 3rem;
    }
    .option {
      text-align: left;
      margin: 5% 2%;
    }
    .btn-group {
      margin-top: 15px;
    }
  }
}

@media screen and (max-width: 600px) {
  .exam-section-inner {
    width: 90%;
    margin: 0 5%;
  }
}
// scrollbar style
.scrollbar-box {
  height: 100%;
  width: 100%;
  overflow-y: auto;
}
.style-3::-webkit-scrollbar-track {
  -webkit-box-shadow: inset 0 0 6px rgba(0,0,0,0.3);
  background-color: #F5F5F5;
}
.style-3::-webkit-scrollbar {
  width: 3px;
  background-color: #F5F5F5;
}
.style-3::-webkit-scrollbar-thumb {
  background-color:rgba(0,0,0,0.8);
}
.option {
  cursor: pointer;
}
.isSelected {
  text-shadow: 0 0 0.2em #87F, 0 0 0.2em #87F,
    0 0 0.2em #87F
}
.vrsdk-marker-info-description {
  pre {
    color: #fff
  }
}
</style>

<style lang="scss">
.vrsdk-marker-info-large-right {
  width:100% !important;
  text-align: center !important;
  h4 {
    margin: auto !important;
  }
}
.vrsdk-marker-info-large-left {
  margin: 20px !important;
  img {
    min-width:300px !important;
  }
}
.vrsdk-marker-info-large-top {
  display: block !important;
}
.vrsdk-pre-custom {
  color: #fff !important;
}
</style>
